import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';

export function useGetAdviceCorrectionReport(id: string) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['correction', 'report', id],
		queryFn: async () => {
			const { data } = await api.get<Blob>(`/advices/planting/report/${id}`, {
				responseType: 'blob',
				params: { forBinding },
			});

			return data;
		},
		enabled: !!id,
	});
}
